const CART_MESSAGES = {
    'coupon-auto-active': 'Este descuento se aplica automáticamente y ya está activo en tu carrito.',
    'coupon-code-unavailable-auto-applied': 'El código ingresado no está disponible. Se aplicó automáticamente un descuento disponible para tu carrito.',
    'coupon-code-unavailable': 'El código ingresado no está disponible.',
    'btl-checkout-disabled': 'Los códigos médicos no están habilitados temporalmente.',
    'btl-coupon-inactive': 'El código médico está inactivo.',
    'btl-coupon-not-started': 'El código médico todavía no inicia su vigencia.',
    'btl-coupon-expired': 'El código médico ha expirado.',
    'btl-coupon-invalid-version': 'El código médico no tiene una versión válida.',
    'btl-product-set-missing': 'No está disponible el catálogo de productos participantes.',
    'btl-no-eligible-products': 'El carrito no contiene productos participantes.',
    'btl-shipping-method-missing': 'No hay un método de envío regular disponible.',
    // Compatibilidad durante el despliegue coordinado con versiones anteriores del backend.
    'El código ingresado no está disponible y se retiró.': 'El código ingresado no está disponible.'
};

export const cartMessageText = value => CART_MESSAGES[value] || value;
